import { useEffect, useState } from "react";

const parseTimeStringToSeconds = (timeStr: string) => {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
};

const formatTime = (totalSeconds: number) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

const Timer = () => {
    const [seconds, setSeconds] = useState(() => {
        const storedTime = localStorage.getItem("loggedIn_time");
        return storedTime ? parseTimeStringToSeconds(storedTime) : 0;
    });

    useEffect(() => {
        const updateTimer = () => {
            setSeconds((prev) => {
                const newTime = prev + 1;
                localStorage.setItem("loggedIn_time", formatTime(newTime));
                return newTime;
            });
        };

        const interval = setInterval(updateTimer, 1000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div 
            style={{
                background: "#f8f9fa",
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50px",
                border: "1px solid #e5e7eb",
                position: "relative"
            }}
            title="Login hours"
        >
            <span style={{ 
                padding: "5px 15px", 
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                color: "#374151",
                fontSize: "14px"
            }}>
                {formatTime(seconds)}
            </span>
        </div>
    );
};

export default Timer;
